import { Routes } from "@angular/router";

export const standardsRoutes: Routes = [
  {
    path: 'standards',
    children: [
      {
        path: '',
        loadComponent: () => import('./views/standards-list-page/standards-list-page.component').then(m => m.StandardsListPageComponent)
      },
      {
        path: ':standardLevelId',
        loadComponent: () => import('./views/standards-level-page/standards-level-page.component').then(m => m.StandardsLevelPageComponent)
      }
    ],
  },
];

export const standardsModalRoutes: Routes = [
  {
    path: 'find-standards',
    outlet: 'modal',
    loadComponent: () =>
      import("./views/find-standards-modal/find-standards-modal.component").then(
        (m) => m.FindStandardsModalComponent
      ),
  },
  {
    path: 'view-standard/:standardItemId',
    outlet: 'modal',
    loadComponent: () => import('./views/view-standard-modal/view-standard-modal.component').then(m => m.ViewStandardModalComponent)
  }
];
